import company from '../data/company.json';
import styles from './AboutSection.module.css';

export default function AboutSection() {
  const { about } = company;
  return (
    <section className={`${styles.section} section`} id="about">
      <div className="container">
        <div className={styles.grid}>
          {/* Left: Team Photo */}
          <div className={styles.imageWrap}>
            <img src={about.teamImage} alt="Our team" className={styles.image} />
            <div className={styles.imageBadge}>
              <span className={styles.badgeNum}>20+</span>
              <span className={styles.badgeText}>Years of<br />Excellence</span>
            </div>
          </div>

          {/* Right: Text */}
          <div className={styles.content}>
            <p className="section-label">About Us</p>
            <h2 className={`section-title ${styles.title}`}>{about.heading}</h2>
            <div className={styles.divider} />
            <p className={styles.para}>{about.paragraph1}</p>
            <p className={styles.para}>{about.paragraph2}</p>
            <div className={styles.badges}>
{['Authorized Agent', 'After-Sales Service', 'Warranty Support', 'Genuine Spare Parts', 'Annual Maintenance Contracts', 'Certified Engineers'].map((b) => (                <span key={b} className={styles.badge}>{b}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
